import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { LoadingPlaceholder } from '@garnish/core';

export const LoadingResults = () => (
  <View style={styles.wrapper} testID="location-loading-results">
    <LoadingPlaceholder rows={5} rowHeight={44} gridGapY={theme.spacing['2']} palette="cream" />
  </View>
);

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: theme.spacing['4'],
  },
});
